import { render, staticRenderFns } from "./CardParametrosConsulta.vue?vue&type=template&id=1e1afaf6&scoped=true"
import script from "./CardParametrosConsulta.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardParametrosConsulta.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CardParametrosConsulta.vue?vue&type=style&index=0&id=1e1afaf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1afaf6",
  null
  
)

export default component.exports